module.exports = __webpack_public_path__ + "media/sanjose_vid.1798dc81.mp4";